/**
 * Pure session helpers for letter template editor navigation / version history.
 */

/**
 * @param {{ dirty: boolean, confirm: () => boolean }} args
 * @returns {boolean}
 */
export function confirmDiscardUnsavedDraft({ dirty, confirm }) {
  if (!dirty) return true;
  if (typeof confirm !== 'function') return false;
  return confirm() === true;
}

/**
 * Decide whether version navigation should proceed.
 * @param {{ dirty: boolean, targetVersion: number, selectedVersion: number|null, confirm: () => boolean }} args
 * @returns {{ action: 'noop' | 'cancel' | 'load', version?: number, mode?: 'detail-only' }}
 */
export function resolveVersionNavigation({ dirty, targetVersion, selectedVersion, confirm }) {
  if (targetVersion === selectedVersion) return { action: 'noop' };
  if (!confirmDiscardUnsavedDraft({ dirty, confirm })) return { action: 'cancel' };
  return { action: 'load', version: targetVersion, mode: 'detail-only' };
}

/**
 * Merge version metadata rows without duplicates. Newest version first.
 * @param {Array<{ version: number }>} existing
 * @param {Array<{ version: number }>} incoming
 */
export function mergeLetterTemplateVersionRows(existing = [], incoming = []) {
  const map = new Map();
  for (const row of existing) {
    if (row && row.version != null) map.set(row.version, row);
  }
  for (const row of incoming) {
    if (row && row.version != null) map.set(row.version, row);
  }
  return [...map.values()].sort((a, b) => Number(b.version) - Number(a.version));
}

/**
 * Duplicate/Archive while dirty is ambiguous (backend uses stored version).
 * @param {{ dirty: boolean, impersonating?: boolean }} args
 */
export function letterTemplateWriteActionsEnabled({ dirty, impersonating = false }) {
  return !dirty && !impersonating;
}
